import React, { Component } from 'react';
import PropTypes from 'prop-types';

const Loader = ({ stroke, height, width, strokeWidth = 2 }) => {
  const defaults = {
    height: height || 40, 
    width: width || 35,
    stroke: stroke || '#fff',
  }

  return (
    <svg className="loader" {...defaults} viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)" strokeWidth={strokeWidth}>
          <circle strokeOpacity=".5" cx="18" cy="18" r="18"/>
          <path d="M36 18c0-9.94-8.06-18-18-18">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="1s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </g>
    </svg>
  )
}

export default Loader;


// WEBPACK FOOTER //
// ./src/components/Loader.js